import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

// Presentational Component
const WidgetListItem = ({ widgetName, categoryName }) => {
	return (
		<li>
			<NavLink to={`/widgets/${categoryName}/${widgetName}`}>{widgetName}</NavLink>
		</li>
	);
};

WidgetListItem.propTypes = {
	widgetName: PropTypes.string.isRequired,
	categoryName: PropTypes.string
};

export default WidgetListItem;



// WEBPACK FOOTER //
// ./src/components/widgets/WidgetListItem.js